<template>
  <div class="animated fadeIn">
    <b-card no-body class="dashboard-card">
      <div class="card-smallHeader card-header-action" v-b-toggle.collapseGestion>
        <i class="fa fa-list-alt mr-2"></i>
        <strong>Tableau de pilotage</strong>
        <div class="card-header-actions">
              <span class="when-opened">
                <i class="icon-arrow-down"></i>
              </span>
          <span class="when-closed">
                <i class="icon-arrow-up"></i>
              </span>
        </div>
      </div>
      <b-collapse id="collapseGestion" :visible="true">
        <b-card-body class="xsmall-padding">
          <table id="dashboardGestion" class="dashboard">
            <thead>
            <tr class="">
              <th class="headerDashboard firstColumn">Campagne active</th>
              <th class="headerDashboard">A affecter</th>
              <th class="headerDashboard">A controler</th>
              <th class="headerDashboard">Total</th>
              <th class="col-separateur"></th>
              <th class="headerDashboard">Contrôlé</th>
              <th class="headerDashboard">Abandonné</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(value) in data" :key="'gestion-row-'+value['id']">
              <td class="text-left" :class="!isEmpty(value['dossiers_a_controler']) && !isEmpty(value['dossiers_a_controler']['gestionnaire_id']) && hasControle(value['dossiers_a_controler']['gestionnaire_id']) ? 'coloredCampagne' : ''">
                <span v-if="!isEmpty(value['dossiers_a_controler']) && !isEmpty(value['dossiers_a_controler']['gestionnaire_id']) && hasControle(value['dossiers_a_controler']['gestionnaire_id'])" :class="!isEmpty(value['dossiers_a_controler']) && hasControle(value['dossiers_a_controler']['gestionnaire_id']) ? 'strongValue' : ''">
                  <strong>{{ value['libelle'] }}</strong>
                </span>
                <span v-else>{{ value['libelle'] }}</span>
              </td>
              <td>
                <a v-if="!isEmpty(value['dossiers_a_affecter'])" :id="`stat_${value['id']}_a_affecter_${value['id']}`" href="#"
                   @click.prevent="getDossiersGestion(value['id'], value['dossiers_a_affecter']['statut_id'])">
                  {{ value['dossiers_a_affecter']['count'] }}
                </a>
                <span v-else> - </span>
              </td>
              <td>
                <a v-if="!isEmpty(value['dossiers_a_controler'])" :id="`stat_${value['id']}_a_controler_${value['id']}`" href="#" 
                :class="!isEmpty(value['dossiers_a_controler']) && hasControle(value['dossiers_a_controler']['gestionnaire_id']) ? 'aControler' : ''"
                   @click.prevent="getDossiersGestion(value['id'], value['dossiers_a_controler']['statut_id'])">
                  {{ value['dossiers_a_controler']['count'] }}
                </a>
                <span v-else> - </span>
              </td>
              <td>
                <a v-if="!isEmpty(value['total']) && value['total'] !== 0" :id="`stat_${value['id']}_total_${value['id']}`" href="#"
                   @click.prevent="getDossiersGestion(value['id'])">
                  {{ value['total'] }}
                </a>
                <span v-else-if="value['total'] === 0"> {{ value['total'] }} </span>
                <span v-else> - </span>
              </td>
              <td class="col-separateur"></td>
              <td>
                <a v-if="!isEmpty(value['dossiers_controle'])" :id="`stat_${value['id']}_controle_${value['id']}`" href="#"
                   @click.prevent="getDossiersGestion(value['id'], value['dossiers_controle']['statut_id'])">
                  {{ value['dossiers_controle']['count'] }}
                </a>
                <span v-else> - </span>
              </td>
              <td>
                <a v-if="!isEmpty(value['dossiers_abandonne'])" :id="`stat_${value['id']}_abandonne_${value['id']}`" href="#"
                   @click.prevent="getDossiersGestion(value['id'], value['dossiers_abandonne']['statut_id'])">
                  {{ value['dossiers_abandonne']['count'] }}
                </a>
                <span v-else> - </span>
              </td>
            </tr>
            </tbody>
          </table>
        </b-card-body>
      </b-collapse>
    </b-card>
    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i>
        <strong>Dossiers</strong>
      </b-card-header>
      <b-card-body>
        <v-server-table @loaded="onLoaded" ref="corbeille_dossiers_table" :columns="columns" :url="url"
                        :options="options" style="overflow: hidden;">
          <div slot="source" slot-scope="props">
            <b>{{ props.row.id }}</b> <br> {{ props.row.canal.libelle }}
          </div>
          <div slot="date_reception" slot-scope="props" v-html="formatDate(props.row.date_reception)">
          </div>
          <div slot="dossier_type" slot-scope="props">
            <span>{{ props.row.type ? props.row.type.libelle : 'n.d' }}</span><br>
            <span v-b-tooltip.hover
                  :title="getLibelleTraitement(props.row,'long')">{{ getLibelleTraitement(props.row, 'court') }}
            </span>
          </div>
          <div slot="siren" slot-scope="props">
            <!-- <b style="color: rgb(217, 65, 139);">{{ props.row.siren ? props.row.siren.siren : 'n.d'
              }} (OAG {{props.row.oag }} OAP {{props.row.oap }})</b><br> -->
              <b style="color: rgb(217, 65, 139);">{{ props.row.siren ? props.row.siren.siren : 'n.d' }} (OAG </b><b style="color: #ff0032;">{{ props.row.oag }}</b>
              <b style="color: rgb(217, 65, 139);">  OAP</b><b style="color: #ffa434;"> {{ props.row.oap }}</b><b style="color: rgb(217, 65, 139);">)</b><br>
            <span class="text-success" :id="`tooltip-rs-${props.row.id}`">
                {{ props.row.siren ? (props.row.siren.raison_sociale.length > 42 ? props.row.siren.raison_sociale.substring(0, 39) + '...' : props.row.siren.raison_sociale) : 'n.d'}}
              </span>
            <b-tooltip v-if="props.row.siren && props.row.siren.raison_sociale.length > 45"
                       :target="`tooltip-rs-${props.row.id}`" triggers="hover" placement="top">
              {{ props.row.siren.raison_sociale }}
            </b-tooltip>
          </div>
          <div slot="produit" slot-scope="props" v-html="getInfosSegmentProduit(props.row)">
          </div>
          <div v-if="getHabilitation(props.row)" slot="nom" slot-scope="props">
            <b style="color: #990000;">{{ props.row.nir ? formatNir(props.row.nir) : 'n.d' }}</b><br>
            <span class="">{{ props.row.nom ? props.row.nom.toUpperCase() + ' ' + props.row.prenom : 'n.d' }}</span>
          </div>
          <div v-else>
            <b style="color: #990000;">Non habilité</b><br>
            <!-- <span class="">{{ props.row.nom ? props.row.nom.toUpperCase() + ' ' + props.row.prenom : 'n.d' }}</span> -->
          </div>
          <div slot="statut_controle" slot-scope="props">
            <span class="">{{ props.row.statut_controle ? props.row.statut_controle : 'n.d' }}</span>
          </div>          
          <div slot="resultat_controle" slot-scope="props">
            <span class="">{{ props.row.resultat_controle ? props.row.resultat_controle : 'n.d' }}</span>
          </div>
          <div slot="affectation_controle" slot-scope="props">
            <span
              class="">{{ props.row.nom_affecte ? props.row.nom_affecte.toUpperCase() + ' ' + props.row.prenom_affecte : 'n.d'
              }}</span>
          </div>
          <div v-if="getHabilitation(props.row)" slot="action" slot-scope="props">
            <b-button type="button"
                      @click.prevent="showDossier(props.row)" class="badge badge-primary p-2">
              <i class="fa fa-search" title="Voir le dossier"></i>
            </b-button>
          </div>
          <div slot="selection" slot-scope="props">
            <b-form-checkbox v-model="selectedRows" :value="props.row.id"
                             :state="errors.checkbox === ''"></b-form-checkbox>
          </div>
          <div slot="h__selection">
            <b-form-checkbox
              v-model="allSelected"
              :indeterminate="indeterminate"
              aria-describedby="items"
              aria-controls="items"
              @change="toggleAll">
            </b-form-checkbox>
          </div>
        </v-server-table>
        <div slot="afterTable">
          <div style="float: left;display: inline-block;">
            <b-button type="button" @click="exportResultat()" class="export-excel-btn mb-2" size="md">
              <i class="fa fa-file-excel-o"></i>&nbsp; Exporter en Excel
            </b-button>
          </div>
          <div style="float: right;display: inline-block;">
            <b-button v-if="canAffecte('autoAffecte')" type="button" @click="launchAffectation('autoAffecte')" title="S'Auto-Affecter les dossiers pour traitement" class="pull-right ml-1 mr-1 mt-1" size="md" variant="success">
              <i class="fa fa-arrow-right"></i><i class="fa fa-user"></i> Auto-Affecter
            </b-button>
            <b-button v-if="canAffecte()" type="button" @click="launchAffectation('affecte')" class="pull-right ml-1 mr-1 mt-1"
                      size="md" variant="primary">
              <i class="fa fa-list" title="Affecter les dossiers pour traitement"></i> Affecter
            </b-button>
            <b-button v-if="canAffecte()" type="button" @click="desaffectation()" class="pull-right ml-1 mr-1 mt-1"
                      size="md" variant="warning">
              <i class="fa fa-eraser" title="Affecter les dossiers pour traitement"></i> Désaffecter
            </b-button>
          </div>
          <span class="field-error inline mr-1 float-right">{{ errors.checkbox }}</span>
        </div>
      </b-card-body>
    </b-card>
    <b-modal centered id="modal-affectation" ref="modal-affectation" title="Affectation des dossiers à un gestionnaire">
      <auto-select
        v-model="gestionnaireGestion"
        :items="gestionnairesGestion"
        :loading="loadingGestionnaire"
        item-value="id"
        item-text="nom"
        menuDefaultPosition="top"
        :placeholder="gestionnaireGestion ? '' : 'Entrer le nom du gestionnaire'"
        disable-filtering-by-search
        @search="onSearchGestionnaireGestion"
        style="display: inline-block;"
        class="w-100"
        :class="{hasError: errors.gestionnaire !== ''}"
      >
        <template #no-data>
          {{ noData ? "Aucun gestionnaire trouvé." : "Il faut au moins 2 caractères pour la recherche." }}
        </template>
        <template slot="item" slot-scope="{ item: gest }">
          <div style="display: flex; align-items: center;">
            <span class="item-name"> {{ gest.nom }} {{ gest.prenom }} </span>
          </div>
        </template>
        <template slot="selection" slot-scope="{ item: gest }">
          <div style="display: flex; align-items: center;">
            <span class="item-name"> {{ gest.nom }} {{ gest.prenom }} </span>
          </div>
        </template>
        <template v-if="loadingGestionnaire" #input-end>
          <img src="https://i.imgur.com/mTNe6tr.gif" class="loading-indicator">
        </template>
      </auto-select>
      <span class="field-error d-block mr-1 ">{{ errors.gestionnaire }}</span>
      <span class="field-error d-block mr-1 ">{{ errors.checkbox }}</span>
      <template v-slot:modal-footer>
        <div class="w-100 text-right">
          <button type="button" class="btn btn-secondary mr-1" @click="closeModalAffectation()">Annuler</button>
          <button type="button" @click="hasOagOapHabilitation" class="btn btn-primary"><i class="fa fa-save"></i>
            Enregistrer
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import {getBaseUrl, getProvider, getIdToken, getAccessToken, getUser} from '@/utils/auth';
  import {isEmpty, downloadFile} from "@/utils/fileHelper";
  import {CoolSelect as AutoSelect} from 'vue-cool-select';
  import controle_dossier_mixin from "../../../mixins/controle-dossier-mixin";
  import dossier_form_mixin from "../../../mixins/dossier-form-mixin";
  import {hasRule, espaceGestionRules as rules} from "@/utils/rulesHelper";
  import {isResponsable, getUserTraitementIds} from "@/utils/userHelper";

  export default {
    name: "CorbeillesCampagne",
    mixins: [controle_dossier_mixin, dossier_form_mixin],
    components: {
      AutoSelect,
    },
    data() {
      let self = this;
      return {
        traitementControleId: null,
        gestionnaireGestion: '',
        gestionnairesGestion: [],
        allTreatment: [],
        loadingGestionnaire: false,
        timeoutId: null,
        noData: false,
        noSearch: 'noSearch',
        campagneId: null,
        statutId: null,
        data: [],
        isEmpty,
        options: {
          headings: {
            'source': 'N° dossier\nCanal récept.',
            'date_reception': 'Date de\nréception',
            'dossier_type': 'Type dossier\nTraitement',
            'siren': 'SIREN\nRaison Sociale',
            'produit': 'Segment\nProduit',
            'nom': 'NIR\nNom Prénom',
            'statut_controle': 'Statut\nContrôle',
            'resultat_controle': 'Résultat\nContrôle',
            'affectation_controle': 'Affectation\nContrôle',
            'action': '#',
            'selection': ''
          },
          columnsClasses: {
            dossier_type: 'pre-formatted tooltip-cell sort-top position-r',
            siren: 'pre-formatted sort-top position-r',
            produit: 'pre-formatted sort-bottom position-r',
            nom: 'pre-formatted sort-bottom min-width-nir position-r',
            gestionnaire: 'pre-formatted position-r',
            resultat_controle: 'pre-formatted position-r',
            statut_controle: 'pre-formatted sort-top position-r',
            affectation_controle: 'pre-formatted sort-top position-r',
            date_reception: 'pre-formatted align-middle sort-middle position-r',
            action: 'align-middle action-xs text-center position-r',
            selection: 'align-middle text-center position-r',
          },
          // rowClassCallback(row) {
          //   return 'row_dossier_' + row.id;
          // },
          rowClassCallback(row) {
            if (!self.getHabilitation(row)) {
              return "dossier-campagne-desactive" // #dcdcdc
            }
          },
          sortable: ['source', 'date_reception', 'dossier_type', 'siren', 'produit', 'nom', 'resultat_controle'],
          filterable: false,
          resizableColumns: true,
          perPage: 25,
          perPageValues: [25, 50, 75, 100],
          orderBy: {column: 'date_reception', ascending: true},
          requestFunction: function (data) {
            data['campagneId'] = self.campagneId;
            data['statutId'] = self.statutId;
            data['noSearch'] = self.noSearch;
            self.url = '/espaceQualite/campagnes/corbeilleDossiers';
            if (self.noSearch !== 'noSearch') {
              self.$store.commit('IS_LOADING', true);
            }
            return axios.get(self.url, {
              params: data
            })
              .then(function (response) {
                if (self.noSearch !== 'noSearch') {
                  self.$store.commit('IS_LOADING', false);
                }
                self.findDossiers = response.data.data;
                self.searchData = data;
                return response;
              })
              .catch(function (e) {
                self.$store.commit('IS_LOADING', false);
                self.$swal({
                  position: 'top',
                  type: 'error',
                  title: 'Attention !!',
                  text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',
                  showConfirmButton: false,
                  timer: 5000
                });
              }.bind(this));
          },
        },
        columns: ['source', 'date_reception', 'dossier_type', 'siren', 'produit', 'nom', 'statut_controle', 'resultat_controle', 'affectation_controle', 'action', 'selection'],
        items: [],
        url: '',
        findDossiers: [],
        errors: {checkbox: '', gestionnaire: ''},
        allSelected: [],
        selectedRows: [],
        indeterminate: false,
        searchData: [],
        hasHabilitation: false,
      }
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common['Authorization'] = getIdToken() + ' ' + getAccessToken()
      this.$axios.defaults.headers.common['Accept'] = 'application/json'
      this.$axios.defaults.headers.common['Provider'] = getProvider()

      if (this.$route.query.campagneId) {
        if (!isEmpty(this.$route.query.statusId)) {
          this.getDossiersGestion(this.$route.query.campagneId, this.$route.query.statusId);
        } else {
          this.getDossiersGestion(this.$route.query.campagneId);
        }
        let query = Object.assign({}, this.$route.query);
        delete query.campagneId;
        delete query.statusId;
        this.$router.replace({query});
      }
    },
    mounted() {
      this.getTraitementControleId();
      this.getCorbeillesStats();
      this.getHabilitation()
    },
    methods: {
      onLoaded() {
        this.$store.commit("IS_LOADING", false);
      },
      hasControle(gestionnaire) {
        let hasControle = _.filter(gestionnaire, function(gestionnaire){
          return getUser().id === gestionnaire
        })
        if (hasControle.length > 0) {
          return true
        } else {
          return false
        }
      },
      getCorbeillesStats() {
        this.$store.commit('IS_LOADING', true);
        this.$axios
          .get('/espaceQualite/campagnes/corbeillesStats')
          .then(response => {
            this.$store.commit('IS_LOADING', false);
            this.data = response.data.data;
          })
          .catch(function (error) {
            self.$store.commit('IS_LOADING', false);
            let textError = 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI';
            if (error.response && error.response.status === 406) {
              textError = error.response.data.message;
            }
            self.displayErrorModal(textError);
          });
      },
      getDossiersGestion(campagne_id, statut_id = null) {
        this.campagneId = campagne_id;
        this.statutId = statut_id;
        this.noSearch = 'search';
        if (!isEmpty(this.$refs['corbeille_dossiers_table'])) {
          this.$refs['corbeille_dossiers_table'].refresh();
        }
      },
      closeModalAffectation() {
        this.$refs['modal-affectation'].hide()
        this.clearError()
        this.gestionnaireGestion = ''
        this.gestionnairesGestion = []
      },
      affecter() {
        if (this.validateDataAffectationGestion()) {
          let self = this;
          this.$swal
            .fire({
              title: "Êtes-vous sûr?",
              text: "voulez-vous affecter ces dossiers pour contrôle ?",
              type: "warning",
              reverseButtons: true,
              showCancelButton: true,
              allowOutsideClick: false,
              cancelButtonColor: "#ff1744",
              confirmButtonText: "Confirmer",
              cancelButtonText: "Annuler"
            })
            .then(result => {
              if (result.value) {
                const dataPost = {
                  'campagneId': this.campagneId,
                  'dossierIds': this.selectedRows,
                  'gestionnaireId': this.gestionnaireGestion,
                  'type': 'affectation',
                };
                this.$store.commit('IS_LOADING', true);
                this.$axios
                  .post('/espaceQualite/campagnes/affectation', dataPost)
                  .then((response) => {
                    let html = '<div class="text-left">';
                    let dossiersAcccepted = ''
                    if (response.data.accepted > 0) {
                      dossiersAcccepted = 'Affectation de ' + response.data.accepted + ' dossiers réalisée avec succès.<br>'
                    } else {
                      dossiersAcccepted = 'Aucun dossier à affecter.<br>'
                    }
                    html = html + '<div class="text-left">' + dossiersAcccepted;
                    if (response.data.rejected > 0) {
                      html = html + response.data.rejected + ' dossiers n\'ont pas été affectés car le gestionnaire n\'a pas les habilitations nécessaires.';
                      for (let dossierId of response.data.dossiersRejected) {
                        if (response.data.dossiersRejected.indexOf(dossierId) === (response.data.dossiersRejected.length - 1)) {
                          html = html + dossierId;
                        } else {
                          html = html + dossierId + ', ';
                        }
                      }
                      html = html + '</div>';
                    }
                    this.getCorbeillesStats();
                    this.$store.commit('IS_LOADING', false);
                    this.selectedRows = [];
                    this.$refs['corbeille_dossiers_table'].refresh();
                    this.gestionnaireGestion = '';
                    this.gestionnairesGestion = [];
                    this.$refs['modal-affectation'].hide();
                    self.$swal({
                      position: 'top',
                      type: 'success',
                      title: 'Affectation de dossiers',
                      html: html,
                      showConfirmButton: false,
                      timer: 0
                    });
                  })
                  .catch(function (error) {
                    self.$store.commit('IS_LOADING', false);
                    let textError = 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI';
                    if (error.response && error.response.status === 406) {
                      textError = error.response.data.message;
                    }
                    self.displayErrorModal(textError);
                  });
              }
            });
        }
      },
      desaffectation() {
        if (this.validateCheckedCheckbox()) {
          let self = this;
          this.$swal
            .fire({
              title: "Êtes-vous sûr?",
              text: "Voulez-vous désaffecter ce(s) dossier(s) ?",
              type: "warning",
              reverseButtons: true,
              showCancelButton: true,
              allowOutsideClick: false,
              cancelButtonColor: "#ff1744",
              confirmButtonText: "Confirmer",
              cancelButtonText: "Annuler"
            })
            .then(result => {
              if (result.value) {
                const dataPost = {
                  'campagneId': this.campagneId,
                  'dossierIds': this.selectedRows,
                  'gestionnaireId': this.gestionnaireGestion,
                  'type': 'desaffectation',
                };
                this.$store.commit('IS_LOADING', true);
                this.$axios
                  .post('/espaceQualite/campagnes/affectation', dataPost)
                  .then((response) => {
                    this.getCorbeillesStats();
                    this.$store.commit('IS_LOADING', false);
                    this.selectedRows = [];
                    this.$refs['corbeille_dossiers_table'].refresh();
                    this.gestionnaireGestion = '';
                    this.gestionnairesGestion = [];
                    self.$swal({
                      position: 'top',
                      type: 'success',
                      title: 'Confirmation',
                      text: 'Désaffectation de contrôle dossiers réalisée avec succès.',
                      showConfirmButton: false,
                      timer: 5000
                    });
                  })
                  .catch(function (error) {
                    let textError = 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI';
                    if (error.response.status === 400) {
                      textError = 'Vous devez choisir au moins un dossier';
                    }
                    if (error.response.status === 406) {
                      textError = error.response.data.message;
                    }
                    self.$store.commit('IS_LOADING', false);
                    self.$swal({
                      position: 'top',
                      type: 'error',
                      title: 'Attention !!',
                      text: textError,
                      showConfirmButton: false,
                      timer: 4000
                    });
                  });
              }
            });
        }
        else {
          this.$swal({
            position: 'top',
            type: 'error',
            title: 'Attention !!',
            text: 'Vous devez d\'abord sélectionner un ou plusieurs dossiers avant de pouvoir faire une désaffectation',
            showConfirmButton: false,
            timer: 4000
          });
        }
      },
      async onSearchGestionnaireGestion(search) {
        let self = this
        const lettersLimit = 1

        this.noData = false
        if (search.length < lettersLimit) {
          this.gestionnairesGestion = []
          this.loadingGestionnaire = false
          return
        }
        this.loadingGestionnaire = true

        clearTimeout(this.timeoutId)
        this.timeoutId = setTimeout(async () => {
          this.$axios
            .get('/espaceGestion/gestionnaire/autocompleteRecherche?query=' + search + '&type=equipe&for=qualite')
            .then(response => {
              this.loadingGestionnaire = false
              this.gestionnairesGestion = response.data
              if (!this.gestionnairesGestion.length) this.noData = true
            })
            .catch(function (error) {
              self.loadingGestionnaire = false
              self.$swal({
                position: 'top',
                type: 'error',
                title: 'Attention !!',
                text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',
                showConfirmButton: false,
                timer: 5000
              })
            })
        }, 500)
      },
      hasOagOapHabilitation() {
        let self = this;
        const dataPost = {
          dossiers_ids: this.selectedRows,
          gestionnaire_id: this.gestionnaireGestion,
        }
        this.$axios.post('/espaceGestion/gestionnaire/hasOagOapHabilitation', dataPost)
          .then(response => {
            if (response.data.errors.length > 0) {
              this.$swal({
                position: "top",
                type: "error",
                title: "Attention !!",
                html: `<ul>${response.data.errors.map(message => `<li>${message}</li>`)}</ul>`,
                showConfirmButton: false,
                timer: 4500
              });
            } else {
              this.affecter();
            }
          })
          .catch(function (error) {
            console.log(error)
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',
              showConfirmButton: false,
              timer: 4000
            });
          });
      },
      validateDataAffectationGestion() {
        let error = false;
        this.clearError();
        error = !this.validateCheckedCheckbox();
        if (this.gestionnaireGestion === '' || this.gestionnaireGestion === null) {
          error = true;
          this.errors.gestionnaire = 'Vous devez séléctionner un gestionnaire'
        }
        return !error
      },
      validateCheckedCheckbox() {
        let error = false
        this.clearError();

        if (this.selectedRows.length === 0) {
          error = true
          this.errors.checkbox = 'Vous devez choisir au moins un dossier.'
        }

        return !error
      },
      clearError() {
        this.errors.checkbox = '';
        this.errors.gestionnaire = '';
      },
      toggleAll(checked) {
        this.selectedRows = checked ? this.$refs['corbeille_dossiers_table'].data.map(item => {
          return item.id
        }) : []
      },
      showDossier(dossier) {
        const dossierIds = this.findDossiers.map((dossier) => dossier.id);
        let query = {
          traitementId: this.traitementControleId,
          campagneId: this.campagneId,
          seqDossiers: dossierIds,
        };
        if(!isEmpty(this.statutId)) {
            query['statutControleId'] = this.statutId;
        }
        this.$router.push({
          path: '/espace-qualite/controle-qualite/dossier/show/' + dossier.id,
          query,
        });
      },
      getTraitementControleId() {
        const dataPost = {
          libelle_technique: 'ij_qualite_prestation',
        };
        this.$axios
          .post("/administration/traitementIdByLibelleTechnique", dataPost)
          .then(response => {
            this.traitementControleId = response.data.data;
          })
          .catch((error) => {
            console.log(error)
          });
      },
      exportResultat() {
        if (this.searchData.length !== 0) {
          let self = this;
          let name = 'export_recherche_dossiers_' + this.getTimestamp();
          let ext = 'csv';
          this.searchData.forExport = true;
          this.$store.commit('IS_LOADING', true);
          this.$axios.get('/espaceQualite/campagnes/export-dossiers', {params: this.searchData, responseType: 'blob'})
            .then(response => {
              this.$store.commit('IS_LOADING', false);
               downloadFile(response, name, ext);
            })
            .catch(function (error) {
              self.$store.commit('IS_LOADING', false);
              self.$swal({
                position: 'top',
                type: 'error',
                title: 'Attention !!',
                text: 'Une erreur est survenue pendant la génération de l\'export, si le problème persiste merci de faire un ticket au support DOSI',
                showConfirmButton: false,
                timer: 5000
              });
            });
        }
      },
      getTimestamp() {
        let date = new Date;
        let day = date.getDate().toString().length === 1 ? '0' + date.getDate().toString() : date.getDate().toString();
        let month = (date.getMonth() + 1).toString().length === 1 ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1).toString();
        let year = date.getFullYear().toString();

        return day + '_' + month + '_' + year;
      },
      getHabilitation(data) {
        let hasHabilitation = false
        let user = getUser();
        if (data !== undefined) {
          let userOags = user.profil_active[0].oags.map(oag => oag.code);
          let userOaps = user.profil_active[0].oaps.map(oap => oap.code);
          if (userOags.indexOf(data.oag) > -1 && userOaps.indexOf(data.oap) > -1) {
            hasHabilitation = true
          }
        }
        return hasHabilitation
      },
      canAffecte(type) {
        let canAutoAffecte = type === "autoAffecte" ? hasRule(rules.CAN_AUTO_AFFECTE) : false;
        // Dans le cas d'une recherche avec traitementId, on regarde si le gestionnaire a le traitement nécessaire pour l'autoAffectation
        // if (canAutoAffecte && !isEmpty(this.$parent.traitementId)) {
        //   let userTraitementIds = getUserTraitementIds();
        //   canAutoAffecte = userTraitementIds.indexOf(parseInt(this.$parent.traitementId, 10)) > -1;
        // }
        return (hasRule(rules.CAN_AFFECTE_DOSSIER) || hasRule(rules.CAN_AFFECTE_DOSSIER_ALL) || isResponsable() || canAutoAffecte)
      },
      launchAffectation(type) {
        if (this.validateCheckedCheckbox()) {
          if (type === 'affecte') {
            this.$refs['modal-affectation'].show();
          } else if (type === 'autoAffecte') {
            this.gestionnaireGestion = getUser().id;
            this.affecter();
          }
        } else {
          this.$swal({
            position: 'top',
            type: 'error',
            title: 'Attention !!',
            text: 'Vous devez d\'abord sélectionner un ou plusieurs dossiers avant de pouvoir faire une affectation',
            showConfirmButton: false,
            timer: 4000
          });
        }
      },
    }
  }
</script>

<style>
  .dashboard {
    background-color: #FFFFFF;
    display: inline-block;
  }

  .dashboard th, .dashboard td {
    padding: 0.25rem 0.75rem;
    border-left: 1px solid #DFDFDF;
    text-align: center;
  }

  .dashboard th:last-child, .dashboard td:last-child {
    border-right: 1px solid #DFDFDF;
  }

  .dashboard tr:last-child td {
    border-bottom: 1px solid #DFDFDF;
  }

  .dashboard tr.row-separateur td {
    border-top: 1px solid #DFDFDF;
    border-bottom: 1px solid #DFDFDF;
    border-right: none;
    border-left: none;
  }

  .dashboard tr:last-child td.col-separateur, .dashboard tr.row-separateur td.col-separateur, td.col-separateur {
    border-top: none;
    border-bottom: none;
  }

  td.disabled {
    background-color: #DFDFDF;
  }

  .dashboard tr:last-child td.btl-only {
    border: none;
    border-top: 1px solid #DFDFDF;
    border-left: 1px solid #DFDFDF;
  }

  .footer {
    padding-top: 0.5rem;
  }

  .borded-top {
    border-top: 1px solid #DFDFDF;
  }

  .headerDashboard {
    background-color: #87b7cd;
    min-width: 100px;
  }

  .headerDashboard.firstColumn {
    min-width: 250px;
  }

  .dashboard .basketDashboard.action {
    padding: 0.25rem 0.1rem;
    border-left: none;
  }

  .dashboard-card {
    margin-bottom: 0.5rem;
  }

  input.input_date:invalid {
    border: solid 1px #ff1744;
  }

  .card-smallHeader {
    padding: 0.15rem 0.75rem;
    border-bottom: 1px solid #DFDFDF;
    background-color: #ECECEC;
  }

  table#dashboardGestion {
    max-height: 500px;
    overflow-y: auto;
  }

  table#dashboardGestion thead tr:nth-child(1) th {
    position: sticky;
    top: 0;
    z-index: 10;
  }

  .coloredCampagne {
    background-color: #3fad89;
  }
  .strongValue {
    font-weight: bold;
    color: white;
  }
  .aControler {
    font-weight: bold;
  }
</style>
